(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen-banners/assets/javascripts/row-banners/andra-chansen-row.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen-banners/assets/javascripts/row-banners/andra-chansen-row.js');

'use strict';

const _excluded = ["classNames", "chances", "isSubscription", "endDate", "isAndraChansenPeriodic"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
class AndraChansenRow extends svs.tur.ball.row.Banner {
  constructor(_ref) {
    let _ref$classNames = _ref.classNames,
      classNames = _ref$classNames === void 0 ? [] : _ref$classNames,
      chances = _ref.chances,
      isSubscription = _ref.isSubscription,
      endDate = _ref.endDate,
      isAndraChansenPeriodic = _ref.isAndraChansenPeriodic,
      props = _objectWithoutProperties(_ref, _excluded);
    super(_objectSpread({
      shouldShowIcon: true,
      bannerOptions: {
        chances,
        isSubscription
      }
    }, props));
    this.endDate = endDate;
    this.addClass('andra-chansen-banner-row', ...classNames);
    this.isAndraChansenPeriodic = isAndraChansenPeriodic;
  }
  render() {
    if (this.numberOfChances) {
      this.show();
    } else {
      this.$el.style.display = 'none';
    }
    return super.render();
  }
  setStatus(_ref2) {
    let chances = _ref2.chances,
      isSubscription = _ref2.isSubscription,
      endDate = _ref2.endDate,
      isAndraChansenPeriodic = _ref2.isAndraChansenPeriodic;
    this.numberOfChances = chances;
    this.isSubscription = isSubscription;
    this.endDate = endDate !== null && endDate !== void 0 ? endDate : this.endDate;
    this.isAndraChansenPeriodic = isAndraChansenPeriodic !== null && isAndraChansenPeriodic !== void 0 ? isAndraChansenPeriodic : this.isAndraChansenPeriodic;
  }

  update(options) {
    const oldNumberOfChances = this.numberOfChances;
    this.setStatus(options);
    if (oldNumberOfChances && !this.numberOfChances) {
      this.hide();
    } else {
      this.$message.removeChild(this.$chances);
      this.$message.appendChild(this.createChancesElement());
      if (!oldNumberOfChances && this.numberOfChances) {
        this.show();
      }
    }
  }

  createDomElements(options) {
    this.setStatus(options);
    this.htmlElement = document.createElement('div');
    this.htmlElement.classList.add('andra-chansen-banner-row-content');
    this.htmlElement.appendChild(this.createMessageElement());
    if (this.shouldShowIcon) {
      this.htmlElement.appendChild(this.createIcon());
    }
    super.createDomElements();
  }
  createMessageElement() {
    this.$message = document.createElement('p');
    this.$message.classList.add('andra-chansen-banner-message');
    this.$message.appendChild(document.createTextNode('Andra Chansen: '));
    this.$message.appendChild(this.createChancesElement());
    return this.$message;
  }
  createChancesElement() {
    this.$chances = document.createElement('span');
    let chancesText = this.numberOfChances === 1 ? '1 chans' : "".concat(this.numberOfChances, " chanser");
    if (this.isSubscription) {
      chancesText += ' varje vecka';
    }
    this.$chances.appendChild(document.createTextNode(chancesText));
    return this.$chances;
  }
  createIcon() {
    const iconHolder = document.createDocumentFragment();

    $(iconHolder).append(svs.ui.icon_button.partials.icon_button({
      content: svs.ui.icon.partials.icon({
        icon: 'information',
        size: 300,
        class: 'js-andra-chansen-row-info-icon'
      })
    }));
    const iconButton = iconHolder.firstChild;
    iconButton.addEventListener('click', () => this.showInfoDialog(iconButton));
    return iconButton;
  }
  showInfoDialog(icon) {
    let message;
    let title;
    if (this.isAndraChansenPeriodic) {
      title = 'En andra chans att bli miljonär';
      message = ['När du spelar Lotto med Joker får du en andra chans att bli miljonär – varje lördag i en extra miljondragning.', 'Varje spelad rad ger dig en chans i dragningen där en rad vinner 1&nbsp;miljon&nbsp;kr.'];
    } else {
      title = 'Du får en andra chans!';
      message = ["Varje g\xE5ng du spelar Lotto med Joker \xE4r du med i Andra Chansen - extradragningen som ger dig chans till 1&nbsp;miljon&nbsp;kr ".concat(svs.utils.date.FormatTime('d/M', this.endDate), "."), 'Varje rad och dragning ger en ny chans till Andra Chansen.'];
    }
    const dialog = new svs.ui.dialog.Contextual({
      area: svs.ui.dialog.area.CONTEXTUAL,
      branding: svs.ui.dialog.branding.TUR,
      attachTo: icon,
      icon: 'exclamation-sign',
      title,
      message: message.map(text => ({
        text,
        type: svs.ui.dialog.message.TEXT,
        align: svs.ui.dialog.message.align.CENTER
      }))
    });
    svs.ui.dialog.api.add(dialog);
  }
}
svs.numbergames.andra_chansen_banners.AndraChansenRow = AndraChansenRow;

 })(window);